module.exports = __webpack_public_path__ + "static/f69fe542c27693185ef9e0d064fae354.png";